import { isOperationSmartAccount } from "src/utils/helper";
import { useTranslation } from "../../../../../hooks";
import { ExactGetFields, ExactPayFields } from "../../types";

interface IProps {
  fields: ExactGetFields | ExactPayFields;
}

const SmartAccountType = ({ fields }: IProps) => {
  const { t } = useTranslation("createSwapRequest");

  const smartAccountType = fields?.rawWalletInfo?.smart_account_type;

  const getSmartAccountType = () => {
    return isOperationSmartAccount(smartAccountType) ? t("yes") : t("no");
  };

  if (fields.walletAddress === "") {
    return <div>{"-"}</div>;
  }

  return <div>{getSmartAccountType()}</div>;
};

export default SmartAccountType;
